import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useMutation, useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import Modal from '../Modal';
import Input from '../Input';
import useMe from '../../hooks/useMe';

const commentsGql = gql`
  query comments($subjectId: ID!, $condominiumId: ID!) {
    subjectComments(subjectId: $subjectId, condominiumId: $condominiumId) {
      text
      user {
        _id
        name
      }
    }
  }
`;

const addCommentsGql = gql`
  mutation addComments($subjectId: ID!, $condominiumId: ID!, $text: String!) {
    subjectAddComment(
      subjectId: $subjectId
      condominiumId: $condominiumId
      text: $text
    ) {
      text
      user {
        _id
        name
      }
    }
  }
`;

export default function SubjectComments({ assembly, subject, toggle }) {
  const [me] = useMe();
  const commentsListRef = useRef();

  const commonArgs = {
    subjectId: subject._id,
    condominiumId: assembly.condominium,
  };

  const { data, stopPolling } = useQuery(commentsGql, {
    skip: !subject._id || !assembly.condominium,
    pollInterval: 5000,
    variables: commonArgs,
  });

  const [input, setInput] = useState('');

  const [addCommentFn, { loading: submitting }] = useMutation(addCommentsGql, {
    variables: {
      ...commonArgs,
      text: input,
    },
    onCompleted: () => setInput(''),
  });

  const submit = e => {
    e.preventDefault();
    if (input.trim().length > 0) return addCommentFn();
    return undefined;
  };

  useEffect(() => {
    commentsListRef.current.scrollTop = commentsListRef.current.scrollHeight;
  }, [data]);

  useEffect(() => {
    return () => stopPolling();
  }, []);

  const comments = useMemo(() => {
    if (!data) return [];

    return data.subjectComments || [];
  }, [data]);

  return (
    <Modal className="bg-light" lg>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Comentários</h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Fechar"
            onClick={toggle}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <ul className="list-group" ref={commentsListRef}>
            {(!comments.length && (
              <div className="d-flex flex-colum justify-content-center h-100">
                Seja o primeiro a comentar (:
              </div>
            )) ||
              comments.map((comment, index) => (
                <li
                  className={`${
                    comment.user._id === me._id ? 'text-right' : 'text-left'
                  } list-group-item`}
                  key={`comment-${index}`}
                >
                  <p className="text-muted">{comment.user.name}</p>
                  <p>{comment.text}</p>
                </li>
              ))}
          </ul>
          <form onSubmit={submit}>
            <div className="input-group input-group-sm mb-3">
              <Input
                onChange={e => setInput(e.target.value)}
                value={input}
                disabled={submitting}
                focus
              />
              <div className="input-group-append">
                <button className="input-group-text" type="submit">{`${
                  submitting ? 'Enviando' : 'Enviar'
                }`}</button>
              </div>
            </div>
            {/* <div className="input-group input-group-sm">
              <Input onChange={e => setInput(e.target.value)} value={input} disabled={submitting} />
              <div className="input-group-addon">
                <span className="input-group-text" disabled={submitting}>
                  {`${submitting ? 'Enviando' : 'Enviar'}`}
                </span>
              </div>
            </div> */}
          </form>
        </div>
      </div>
    </Modal>
  );
}
